<template>
  <div>
    <div class="form-group d-flex flex-column"  v-if="validToSave()">
      <label class="text-center"> {{$t('ct-label-save-item')}}</label>

      <div class="form" style="text-align: center;">

        <input
          type="text"
          placeholder="Description "
          v-model="description"
          class="form-control"
        />

        <button
          v-if="validToSave()"
          class="cheetah-button cheetah-button-color-success cheetah-button-size-large"
          @click="openSave"
        >
          <i class="svg-icon svgi-save" />
          {{ labelDesc }}
        </button>

      </div>

      <alert-box-component>
        <p
          slot="content"
          v-text="$t('ct-warning-save-item')"
        />
      </alert-box-component>
    </div>

    <sweet-modal style="z-index: 9000" ref="modalName" width="30%" hide-close-button blocking>

      <div class="form-group">
        <label for="description_element">{{$t('ct-save-element-name-item')}}</label>
        <input type="text" name="name" v-model="description" id="description_element" class="form-control"
               :class="{ 'is-invalid': errors.has('description')}" @keyup="errors.clear('description')" required>
        <span
          v-if="errors.has('description')"
          class="invalid-feedback"
          v-text="errors.get('description')"
        ></span>
      </div>

      <button slot="button" class="btn btn-outline-light mt-2" @click="closeSave">{{ $t('ct-cancel') }}
      </button>
      <button slot="button" class="btn btn-outline-primary mt-2" @click="save" data-ba-i="save-element-as-personal">{{ $t('ct-save') }}</button>

    </sweet-modal>
  </div>
</template>

<script>

	import {SweetModal} from 'sweet-modal-vue';
	import Errors from '../../../js/base/Errors';
	import {store as StoreItem} from '../../../js/services/editor/userDefaultItems'

  import AlertBoxComponent from '../../commons/AlertBoxComponent'

	export default {
		name: 'SaveItemComponent',
		components: {
			SweetModal,
      StoreItem,
      AlertBoxComponent
		},
		data() {
			return {
				errors: new Errors(),
				description: '',
				element: null,
				labelDesc: 'Save as default Element',
				headers: {
					'authorization': 'Bearer ' + localStorage.getItem('token')
				}
			};
		},
		methods: {

			openSave() {
				if (this.description === '') {
					this.$snotify.error(
						'Description is required'
					);
				} else {
					this.save();
				}
			},

			closeSave() {
				this.description = '';
				this.$refs.modalName.close();
			},

			validToSave() {
				if (this.element !== null && typeof this.element !== 'undefined') {
				  if(this.element.name != 'slidervideoitem' && this.element.name !== 'ContentNavUser' && this.element.name !== 'ButtonUser'){
					  return true;
          }else{
				    return false;
          }
				} else {
					return false;
				}
			},

			save() {

				if (this.description && this.description.length > 0 && this.description.trim().length > 0) {

					let element = this.element.$el;

					let name = '';

					element.classList.forEach(cls => {
						if (cls === 'sitebuilder-element-panel') {
							name = 'PanelElement';
						}
					})


					if (name === '') {

						name = element.getAttribute('element');

					}


					let savePanel = {};
					savePanel.name = name;
					savePanel.description = this.description;
					savePanel.config = element.getAttribute('config-properties');
					savePanel.app = 1;
					savePanel.childs = [];


					switch (name) {
            case 'VideoGalleryGroupComponent' :
            case 'AccordionGroupComponent' :
            case 'GroupMenuComponent' :
            case 'SliderGroupComponent' :
						case 'BoxComponent' : {

              savePanel.config =  element.getAttribute('config-properties');
              savePanel.childs = this.$eventHub.getElement(element.getAttribute('id')).childs;

							this.store(savePanel);

							break;
						}
						case 'PanelElement' : {
							savePanel.config = element.firstChild.getAttribute('config-properties');
              savePanel.childs = this.$eventHub.getElement(element.firstChild.getAttribute('id')).childs;
							savePanel.app = 0;

							this.store(savePanel);

							break;
						}
						default: {
							savePanel.name = name;
							savePanel.description = this.description;
							savePanel.app = 1;
							savePanel.config = element.getAttribute('config-properties');
							savePanel.childs = [];
							this.store(savePanel);
						}
					}
				} else {
					this.errors.add('name', 'validation-required');
				}

				this.$root.$emit('hideSaveElement');
			},

			store(obj) {
				obj.content = JSON.stringify(obj);
				StoreItem(obj)
					.then(res => {
						if (res.data.success) {
							this.$snotify.success(
								'Save element'
							);
						} else {
							this.$snotify.error(
								res.data.error
							);
						}

						this.closeSave();
					})
					.catch(error => {
						console.warn(error);
						this.$snotify.error(
							'There was an error saving your item'
						);
					});
			},

			setValues(elem) {

        this.labelDesc = this.$t('ct-save-personal-element')
				this.element = elem;
			}
		}
	};
</script>

<style scoped lang="scss">

  .form {
    button {
      margin: 15px 0px;
    }
  }
  .form-group {
    overflow: hidden;
  }

  .image-item {
    width: 140px;
    height: 70px;
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  .image-item.focused {
    outline: 2px solid blue;
  }

  .image-item img {
    width: 100px;
    height: 50px;
  }

  .image-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

</style>

<style lang="scss">


  .modal-save-element .sweet-modal {

    .sweet-content {
      max-height: 70vh !important;
      overflow: auto;
      text-align: left;
    }

    .btn {
      cursor: pointer;
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/SaveItem.vue